const CANVAS_ITEM_TYPE_KEY_VALUE: Record<string, number> = {
  storyboard_item: 2,
  storyboardItem: 2,
  asset_image: 4,
  assetImage: 4,
  asset_tag_image: 5,
  assetTagImage: 5,
  storyboard_entity: 7,
  storyboardEntity: 7,
  storyboard_plan_image: 8,
  storyboardPlanImage: 8,
  storyboard_plan_history_image: 9,
  storyboardPlanHistoryImage: 9,
  storyboard_plan_video: 12,
  storyboardPlanVideo: 12,
  storyboard_plan_history_video: 13,
  storyboardPlanHistoryVideo: 13,
  resource_pin: 15,
  resourcePin: 15,
  // 仅用于把迁移前的本地坐标匹配到同一 resource pin。
  canvas_media_snapshot: 15,
  canvasMediaSnapshot: 15,
  reference_asset_board: 16,
  referenceAssetBoard: 16,
  uploaded_attachment: 17,
  uploadedAttachment: 17,
  storyboard_dialogue: 18,
  storyboardDialogue: 18,
  storyboardDialogueGroup: 18,
  storyboard_voiceover: 19,
  storyboardVoiceover: 19,
  storyboardVoiceoverGroup: 19,
  storyboard_sound_effect: 20,
  storyboardSoundEffect: 20,
  storyboardSoundEffectGroup: 20,
};

export function isCanvasResourcePinItemType(itemType: unknown): boolean {
  return itemType === 'resource_pin' || itemType === 'canvas_media_snapshot';
}

/** 画布自有持久节点：远端删除后需从 layout 缓存 / pending 清掉，避免残影。 */
export function isPersistentCanvasLayoutItemType(itemType: unknown): boolean {
  return isCanvasResourcePinItemType(itemType) || itemType === 'storyboard_temporary_video';
}

export function getCanvasLayoutItemIdentityKey(item: {
  itemType: unknown;
  itemId: string;
}): string {
  const itemType =
    typeof item.itemType === 'number'
      ? item.itemType
      : typeof item.itemType === 'string'
        ? (CANVAS_ITEM_TYPE_KEY_VALUE[item.itemType] ?? item.itemType)
        : item.itemType;
  return `${String(itemType)}:${item.itemId}`;
}
